import React, { useState, useEffect } from "react";
import format from "date-fns/format";
import PropTypes from "prop-types";

import { SVGIcon2 } from "./common/SVGIconV2";

const getCurrentTime = () => {
  return format(new Date(), "HH:mm");
};

const Clock = ({ isIconVisible }) => {
  const [time, setTime] = useState(getCurrentTime());

  useEffect(() => {
    const intervalId = setInterval(() => setTime(getCurrentTime()), 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <div className="aCclock">
      {isIconVisible && (
        <div>
          <SVGIcon2 iconName="clock" />
        </div>
      )}
      <div>{time}</div>
    </div>
  );
};

Clock.propTypes = {
  isIconVisible: PropTypes.bool
};

Clock.defaultProps = {
  isIconVisible: false
};

export default React.memo(Clock);
